<template>
  <div class="wrapper">
    <img class="img" src="../../assets/images/equity/qybj_01.jpg" alt="">
    <img class="img" src="../../assets/images/equity/qybj_02.jpg" alt="">
    <img class="img" src="../../assets/images/equity/qybj_03.jpg" alt="">
    <img class="img" src="../../assets/images/equity/qybj_04.jpg" alt="">
    <img class="img" src="../../assets/images/equity/qybj_05.jpg" alt="">
    <img class="img" src="../../assets/images/equity/qybj_06.jpg" alt="">
    <div v-if="type!='show'" class="btn" @click.stop="gobuy">
      <span>申请权益卡</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      type:''
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters(["agentText", "directorText"]),
  },
  methods: {
    gobuy() {
      this.$router.push({
        path: "/equityPlaceorder",
      });
    },
  },
  created() {},
  activated() {},
  mounted() {
    this.type = this.$route.query.type||''
    document.title = "权益详情";
    let option = {
      title: '有米@'+this.userInfo.name+'的店铺',
      desc: "欢迎光临我的店铺",
      link: location.origin + "/?supNbr=" + this.userInfo.nbr,
      images: this.userInfo.imgUrl,
    };
    this.weChatShare(option)
  },
  destroyed() {
  },
};
</script>
<style scoped lang='stylus'>
</style>
<style scoped lang="less">
.wrapper{
  background: #fff;
  padding-bottom: 1.12rem;
}
.img{
  width: 100vw;
}
.btn{
  position: fixed;
  bottom: .12rem;
  left: .3rem;
  width: 6.9rem;
  height: .88rem;
  border-radius: .44rem;
  background: #E52B25;
  display: flex;
  justify-content: center;
  align-items: center;
  span{
    font-size: .3rem;
    color: #fff;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/equity/equityDetail.vue